import { BoardProvider } from './BoardProvider.js';
import { Effectifs } from './ServiceLists.js';

/**
 * Composition root for the « Effectifs » page (ARCHITECTURE.md §2, R8).
 *
 * Its own file rather than an export from `ServiceLists.tsx`, because that
 * module is also imported by **staff.*** for the phone tabs (`ServiceTabs`) and
 * `BoardProvider` reaches the app-local `supabase.js`. Putting the two in one
 * module would drag the reception app's Supabase client into the staff bundle —
 * the kind of coupling a composition root exists to keep in one place.
 *
 * Both cockpits mount THIS: bos.* under Opérations, reception.* as a top-level
 * link. One wiring point, two deployments, exactly as `Planning` does.
 */
export function EffectifsPage() {
  return (
    <BoardProvider>
      <Effectifs />
    </BoardProvider>
  );
}
